export const socialLoginFactory =
  (callback) =>
  (provider, invitationToken = null, signupCode = null) => {
    let url = `/api/v1/auth/social/signin?provider=${provider}`;
    if (invitationToken) url += `&invitationToken=${invitationToken}`;
    if (signupCode) url += `&signupCode=${encodeURIComponent(signupCode)}`;
    openWindow(callback, url);
  };

function openWindow(callback, url) {
  const width = 450;
  const height = 730;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  const bc = new BroadcastChannel("auth");
  bc.onmessage = (event) => {
    // handle event.data posted from your popup
    // console.debug("bc event received", event);
    callback(event);
  };
  window.open(
    url,
    "_blank",
    `popup,menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, top=${top}, left=${left}`
  );
}
